import React, { useEffect, useRef } from "react";

import "./style.scss";
import { useElementHeight } from "../../hooks/index";
import { isMobile } from "../../utils/tools";

interface Props {
  style?: React.CSSProperties;
  children: React.ReactNode;
  className?: string;
  hoveredIndex: number | null;
  index: number;
  initTop?: number;
}

const HoverCard = (props: Props) => {
  const {
    style = {},
    children,
    className = "",
    hoveredIndex,
    index = 0,
    initTop = 0,
  } = props;

  const ref = useRef(null);

  const getHeight = () => {
    if (ref.current) {
      const { height } = (ref.current as any).getBoundingClientRect();
      return height;
    }
    return 0;
  };

  const getTop = () => {
    const child: any = ref.current;
    const parent: any = document.querySelector(".hover-list");
    const childRect = child.getBoundingClientRect();
    const parentRect = parent.getBoundingClientRect();
    const topRelativeToParent = childRect.top - parentRect.top;
    return topRelativeToParent;
  };

  const reset = (hoverBlock: any) => {
    hoverBlock.style.transition = "unset";
    hoverBlock.style.zIndex = "-1";
    hoverBlock.style.top = initTop + "px";
  };

  useElementHeight((height: number) => {
    if (isMobile()) return false;
    if (index === hoveredIndex) {
      const hoverBlock: any = document.querySelector(`.hover-block`);
      hoverBlock.style.height = `${height}px`;
    }
  }, ref);

  useEffect(() => {
    if (isMobile()) return () => {};
    const hoverBlock: any = document.querySelector(`.hover-block`);
    if (index === hoveredIndex) {
      const top = getTop();
      const height = getHeight();

      if (hoveredIndex !== null) {
        hoverBlock.style.transition =
          hoverBlock.style.zIndex === "-1" ? "unset" : "all 0.3s";
        hoverBlock.style.height = `${height}px`;
        hoverBlock.style.zIndex = "1";
        hoverBlock.style.top = top + "px";
      } else {
        reset(hoverBlock);
      }
    } else {
      if (hoveredIndex === null) reset(hoverBlock);
    }
  }, [hoveredIndex]);

  return (
    <div className={`hover-card ${className}`} style={style} ref={ref}>
      {children}
    </div>
  );
};

export default HoverCard;
